import {createSelector} from "reselect";
import {State} from "../../../reducers";

const adminOnlinePublicationsState = (state: State) => state.adminOnlinePublications;

export const onlinePublications = createSelector(adminOnlinePublicationsState, state => state.articles);
